import React from "react";
import { Link } from "react-router-dom";
import Container from "../hoc/Container";
import { CONSENT_PATH, OPERATOR, PRIVACY_PATH } from "../legal/operator";
import { List, MailLink, Section } from "../legal/policyBlocks";

function CookiesInfoPage() {
  return (
    <Container>
      <section className="main-content-block">
        <h1 className="main-title">Мы используем cookie</h1>
        <div className="offer-text policy-text">
          <p className="policy-operator">
            Оператор персональных данных — {OPERATOR.fullName}, ИНН{" "}
            {OPERATOR.inn}, ОГРНИП {OPERATOR.ogrnip}.
          </p>
          <p>
            Cookie — небольшие файлы, которые сайт{" "}
            <Link className="policy-link" to="/">
              trendy-eng-shop.ru
            </Link>{" "}
            сохраняет в браузере, чтобы работать корректно и понимать, как им
            пользуются.
          </p>

          <Section id="kinds" title="Какие cookie мы используем">
            <List
              items={[
                "технические — нужны для оформления заказа, корзины и входа в личный кабинет; без них сайт не работает;",
                "аналитические — cookie сервиса Яндекс Метрика (ООО «Яндекс»): число посещений, просмотренные страницы, сведения о браузере и устройстве, IP-адрес, а также запись действий на страницах (Вебвизор: переходы, прокрутка, нажатия). Мы используем их, чтобы делать сайт удобнее, и видим статистику только в обобщённом виде.",
                "защитные — при проверке «Я не робот» на оформлении заказа или входе в личный кабинет сервис Yandex SmartCaptcha (ООО «Яндекс.Облако») может использовать собственные cookie и сведения о браузере и устройстве, чтобы отличить человека от программы.",
              ]}
            />
          </Section>

          <Section id="term" title="Сроки и отказ">
            <p>
              Данные аналитики хранятся не более 12 месяцев. Отключить cookie
              можно в настройках браузера — отдельно для каждого браузера и
              устройства. Без технических cookie часть функций сайта, например
              оформление заказа, станет недоступной.
            </p>
            <p>
              Отозвать согласие на обработку данных можно письмом на{" "}
              <MailLink /> с темой «Персональные данные».
            </p>
          </Section>

          <p>
            Подробнее — в{" "}
            <Link className="policy-link" to={PRIVACY_PATH}>
              Политике обработки персональных данных
            </Link>{" "}
            и{" "}
            <Link className="policy-link" to={CONSENT_PATH}>
              Согласии на обработку персональных данных
            </Link>
            .
          </p>
        </div>
      </section>
    </Container>
  );
}

export default CookiesInfoPage;
